import React, { Component } from "react";
import moment from "moment";
import { hashHistory } from "react-router";

import { connect } from "react-redux";
import { tnmformatnumber, invformatnumber } from "../../services/tnminvnumbers";
import downloadPDF from "./invPDFDownload";
import Roundy from "../../services/roundy";
import PaymentModal from "../accounting/invoices/paymentmodal";
import "./pdf.css";
import {
  updateservice,
  createservice,
  grabserviceredux,
  getservice,
  deleteservice
} from "./../../services/crudservice";
import {
  Form,
  Icon,
  Grid,
  Divider,
  Button,
  Image,
  Checkbox,
  Header,
  Modal,
  Table
} from "semantic-ui-react";
import { app } from "../..";
class invpdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tnms: [],
      invoice: null,
      tminfo: null,
      totalhours: null,
      included_tms: [],
      orphan_tms: []
    };
  }

  pdfDownload(tminfo) {
    downloadPDF({
      ...tminfo,
      entries: this.state.entries
    });
  }

  componentDidMount() {
    if (!this.props.invoices.length) {
      grabserviceredux("invoices", "invoiceReducer");
    }
    if (!this.props.tnms.length) {
      grabserviceredux("tmsheets", "tnmReducer");
    }
    this.grabInvoice();
  }
  grabInvoice() {
    getservice("invoices", this.props.params.invid).then(invoice => {
      this.setState({
        invoice,
        showModal: false,
      });
    });
  }

  getInfo(invoice) {
    let response = this.state.invoice.pdftmlist;
    let tmlist = [];
    let custtms = [];

    let currentTotal = 0;
    let prevTotal = 0;
    let wodlist = [];
    let rootwod = invoice.workordernumber;
    let invwod = this.props.wods.find(
      wod => wod.workOrderNbr === invoice.workordernumber
    );
    if (invwod.invWorkOrderMain) {
      rootwod = rootwod.slice(0, 7);
      rootwod = this.props.wods.find(wod => wod.workOrderNbr === rootwod);
      console.log('root wod', rootwod);
      wodlist = this.props.wods.filter(
        wod =>
          wod.workOrderNbr.slice(0, 7) === rootwod.workOrderNbr &&
          wod.invWorkOrderMain
      );
    } else {
      rootwod = this.props.wods.find(wod => wod.workOrderNbr === rootwod);
      wodlist = this.props.wods.filter(
        wod => wod.workOrderNbr === invoice.workordernumber
      );
    }

    var billing = this.props.billing.find(
      bill => bill.id === rootwod.billingNbr
    );
    // console.log("Wod List", wodlist);
    if (response.length && !invoice.fixedpriceinv) {
      // console.log("tmlist", response);
      // if it is a fixed job it will not have tnms in the query
      response.forEach(tm => {
        tm.amount = tm.calc_amount;
        if (parseInt(tm.invoicenumber) === invoice.number) {
          tmlist = tmlist.concat(tm);
        } else {
          custtms = custtms.concat(tm);
        }
      });
      wodlist = wodlist.map(wod => {
        // console.log('wodlistitem', wod.workOrderNbr);
        let currenttms = [];
        let prevtotal = 0;
        let currenttotal = 0;
        let wodtms = response.filter(
          tm => tm.workordernumber === wod.workOrderNbr
        );
        console.log("WOD TMS", wodtms);
        if (wodtms.length) {
          wodtms.forEach(tm => {
            if (parseInt(tm.invoicenumber) === invoice.number) {
              currenttotal += tm.amount;
              currenttms = currenttms.concat(tm);
              currentTotal += tm.amount;
            } else {
              console.log("Previouse invoice " + tm.amount);
              prevtotal += tm.amount;
              prevTotal += tm.amount;
            }
          });
          currenttotal = Roundy(currenttotal);
          let subtotal = parseFloat(currenttotal) + parseFloat(prevtotal);
          subtotal = Roundy(subtotal);
          prevtotal = Roundy(prevtotal);
          return {
            workOrderNbr: wod.workOrderNbr,
            description: wod.description,
            currenttms: currenttms,
            currenttotal,
            subtotal: subtotal,
            prevtotal
          };
        } else {
          return {
            workOrderNbr: wod.workOrderNbr,
            description: wod.description,
            currenttms: [],
            currenttotal: 0,
            subtotal: 0,
            prevtotal: 0
          };
        }
      });
    } else if (invoice.fixedpriceinv) {
      this.props.invoices.forEach(inv => {
        if (
          inv.id !== invoice.id &&
          inv.workordernumber === invoice.workordernumber &&
          moment(invoice.periodenddate).isSameOrAfter(moment(inv.periodenddate))
        ) {
          prevTotal += inv.amount;
          console.log("prev invoice", prevTotal);
        }
      });
      currentTotal = invoice.amount;
      wodlist = [
        {
          workOrderNbr: rootwod.workOrderNbr,
          description: rootwod.description,
          currenttms: [],
          currenttotal: Roundy(invoice.amount),
          subtotal: Roundy(parseFloat(prevTotal) + parseFloat(invoice.amount)),
          prevtotal: Roundy(prevTotal)
        }
      ];
    }
    console.log("invoice billing", billing);

    prevTotal = Roundy(prevTotal);
    currentTotal = Roundy(currentTotal);
    let SubTotal = parseFloat(prevTotal) + parseFloat(currentTotal);
    console.log("subTotal", SubTotal);

    SubTotal = Roundy(SubTotal);
    // let billing = this.props.billing.find(
    //   bill => bill.custnumber === this.state.invoice.custnumber
    // );
    let custinfo = this.props.custinfo.find(
      cust => cust.custnumber === invoice.custnumber
    );

    invoice = {
      ...invoice,
      rootwod,
      wodlist,
      billing,
      tmlist,
      custinfo,
      custtms,
      currentTotal,
      prevTotal,
      SubTotal
    };
    invoice.Remaining =
      parseFloat(invoice.rootwod.budget) +
      parseFloat(invoice.rootwod.supplements) -
      (parseFloat(invoice.SubTotal) + parseFloat(invoice.rootwod.prevYearAdj));
    invoice.Remaining = Roundy(invoice.Remaining);
    if (!invoice.fixedpriceinv && tmlist.length) {
      invoice.periodbegindate = tmlist[0].wedate;
      invoice.periodenddate = tmlist[tmlist.length - 1].wedate;
    }

    console.log("super invoice", invoice);

    return invoice;
  }
  gentmlist(invoice) {
    if (invoice.tmlist.length > 8) {
      return <p> Various </p>;
    } else {
      return invoice.tmlist.map(tm => {
        return <p> {tnmformatnumber(tm)} </p>;
      });
    }
  }
  getchecked(tnm) {
    let param = tnm.invoicenumber ? "included_tms" : "orphan_tms";

    let tmlist = Array.from(this.state[param]);
    return tmlist.findIndex(tl => tl.id === tnm.id) > -1 ? true : false;
  }
  handleCheck(tnm) {
    let param = tnm.invoicenumber ? "included_tms" : "orphan_tms";
    let tmlist = Array.from(this.state[param]);
    let tm_index = tmlist.findIndex(tl => tl.id === tnm.id);
    if (tm_index > -1) {
      tmlist.splice(tm_index, 1);
    } else {
      tmlist = tmlist.concat(tnm);
    }
    this.setState({ [param]: tmlist });
  }
  gentmlistTable() {
    if (this.state.invoice.tmsheets) {
      return this.state.invoice.tmsheets.map(tnm => {
        return (
          <Table.Row positive={tnm.invoicenumber}>
            <Table.Cell
              selectable
              onClick={() =>
                hashHistory.push("/work-orders/" + tnm.workordernumber)
              }
            >
              {tnm.workordernumber}
            </Table.Cell>
            <Table.Cell
              selectable
              onClick={() => hashHistory.push("/tmlist/" + tnm.id)}
            >
              {tnmformatnumber(tnm)}
            </Table.Cell>
            <Table.Cell>{moment(tnm.wedate).format("MM/DD/YY")}</Table.Cell>
            <Table.Cell>{"$" + Roundy(tnm.laborfee)}</Table.Cell>
            <Table.Cell>{"$" + Roundy(tnm.materialfee)}</Table.Cell>

            <Table.Cell id="Printbtn">
              <Checkbox
                disabled={this.state.invoice.fixedpriceinv}
                checked={this.getchecked(tnm)}
                onChange={() => this.handleCheck(tnm)}
              />
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }

  genorphantmlistTable() {
    if (this.state.invoice.orphan_tms) {
      return this.state.invoice.orphan_tms.map(tnm => {
        return (
          <Table.Row positive={tnm.invoicenumber}>
            <Table.Cell
              selectable
              onClick={() =>
                hashHistory.push("/work-orders/" + tnm.workordernumber)
              }
            >
              {tnm.workordernumber}
            </Table.Cell>
            <Table.Cell
              selectable
              onClick={() => hashHistory.push("/tmlist/" + tnm.id)}
            >
              {tnmformatnumber(tnm)}
            </Table.Cell>
            <Table.Cell>{moment(tnm.wedate).format("MM/DD/YY")}</Table.Cell>
            <Table.Cell>{"$" + Roundy(tnm.laborfee)}</Table.Cell>
            <Table.Cell>{"$" + Roundy(tnm.materialfee)}</Table.Cell>

            <Table.Cell id="Printbtn">
              <Checkbox
                disabled={this.state.invoice.fixedpriceinv}
                checked={this.getchecked(tnm)}
                onChange={() => this.handleCheck(tnm)}
              />
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  genTable(invoice) {
    if (invoice.wodlist.length) {
      return invoice.wodlist.map(wod => {
        return (
          <Table.Row active={wod.currenttotal}>
            <Table.Cell> {wod.workOrderNbr} </Table.Cell>
            <Table.Cell> {wod.description} </Table.Cell>
            <Table.Cell> $ {wod.currenttotal} </Table.Cell>
            <Table.Cell> $ {wod.prevtotal} </Table.Cell>
            <Table.Cell> $ {wod.subtotal} </Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  fixAmount(invoice) {
    // console.log(invoice);

    app
      .service("invoices")
      .patch(invoice.id, {
        amount: this.state.invoice.calc_amount
      })
      .then(() => this.grabInvoice());
  }
  add_orphaned_tnms() {
    Promise.all(
      this.state.orphan_tms.map(t => {
        updateservice(
          "tmsheets",
          { ...t, invoicenumber: this.state.invoice.number.toString() },
          t.id
        );
      })
    ).then(() => {
      this.setState({
        orphan_modal: false,
        orphan_tms: [],
        included_tms: []
      });
      this.grabInvoice();
    });
  }
  remove_tnms() {
    Promise.all(
      this.state.included_tms.map(t => {
        updateservice("tmsheets", { ...t, invoicenumber: null }, t.id);
      })
    ).then(() => {
      this.setState({
        orphan_modal: false,
        orphan_tms: [],
        included_tms: []
      });
      this.grabInvoice();
    });
  }

  render() {
    var invoice;
    var tempinv = this.props.invoices.find(
      inv => inv.id == this.props.params.invid
    );
    console.log("myinvoice", tempinv);
    if (this.state.invoice) {
      if (
        tempinv &&
        this.props.tnms &&
        this.props.tnms.length &&
        this.props.wods &&
        this.props.wods.length &&
        this.props.billing
      ) {
        invoice = this.getInfo(this.state.invoice);
      }
      if (invoice) {
        console.log(
          "invoice",
          invoice,
          "wodlist",
          invoice.wodlist,
          "billing",
          invoice.billing
        );
      }

      if (
        invoice &&
        this.props.custinfo &&
        invoice.wodlist &&
        invoice.billing &&
        this.props.billing
      ) {
        return (
          <div className="invPDF">
            <Grid>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Image
                    size="large"
                    src={require("../estimates/custPrintLetterhead.png")}
                  />
                </Grid.Column>
                <Grid.Column textAlign="center" width={4}>
                  <h1> INVOICE </h1>
                </Grid.Column>
              </Grid.Row>
              <Divider />
              <Grid.Row>
                <Grid.Column width={5}>
                  <h2> SOLD TO: </h2> <h4> {invoice.billing.companyname1} </h4>
                  <h4> {invoice.billing.street1} </h4>
                  <h4>
                    {invoice.billing.city}, {invoice.billing.state}
                  </h4>
                  <h2> REMIT TO: </h2> <h4> 8390 Currency Dr. </h4>
                  <h4> Riviera Beach Fl .33404 Unit 4 </h4>
                  <h4> Phone: 561 - 844 - 8886 </h4>
                  <h4> Fax: 561 - 842 - 3929 </h4>
                </Grid.Column>
                <Grid.Column width={5}>
                  <span>
                    <strong> Number: </strong> {invformatnumber(invoice)}
                  </span>
                  <div>
                    <span>
                      <strong> Date: </strong> {invoice.createdate}
                    </span>
                  </div>
                  <div>
                    <span>
                      <strong> Purchase Order: </strong> {invoice.rootwod.poNbr}
                    </span>
                  </div>
                  <div>
                    <span>
                      <strong> EDF#: </strong> {invoice.rootwod.workOrderNbr}
                    </span>
                  </div>
                  <span>
                    <strong> SOW# </strong> {invoice.rootwod.acctNbr}
                  </span>
                  <div>
                    <span>
                      <strong> T & M 's included:</strong>
                      {this.gentmlist(invoice)}
                    </span>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={10} textAlign="left">
                  <span>
                    <strong> Period: </strong> {invoice.periodbegindate}
                    TO {invoice.periodenddate}
                  </span>
                  <div>
                    <strong> Task Description: </strong>
                    {invoice.rootwod.description}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={10}>
                  <Table singleLine>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell> WO# </Table.HeaderCell>
                        <Table.HeaderCell> Task Description </Table.HeaderCell>
                        <Table.HeaderCell> Current </Table.HeaderCell>
                        <Table.HeaderCell> Prev. </Table.HeaderCell>
                        <Table.HeaderCell> Sub - Total </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body> {this.genTable(invoice)} </Table.Body>
                    <Table.Footer>
                      <Table.Row>
                        <Table.HeaderCell> Totals: </Table.HeaderCell>
                        <Table.HeaderCell />
                        <Table.HeaderCell>
                          $ {invoice.currentTotal}
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                          $ {invoice.prevTotal}
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                          $ {invoice.SubTotal}
                        </Table.HeaderCell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Button
                            icon
                            onClick={() => this.fixAmount(invoice)}
                            disabled={
                              Roundy(this.state.invoice.amount) ===
                                Roundy(this.state.invoice.calc_amount) ||
                              this.state.invoice.fixedpriceinv
                            }
                          >
                            <Icon name="smile" /> Fix Total
                          </Button>
                          <Button
                            icon
                            positive
                            onClick={() =>
                              this.setState({ orphan_modal: true })
                            }
                          >
                            <Icon name="clipboard list" /> Manage T&M's
                          </Button>
                          <Button
                            primary
                            icon
                            onClick={() => this.pdfDownload(invoice)}
                          >
                            <Icon name="download" /> Download
                          </Button>
                          <Button
                            positive
                            onClick={() =>
                              this.setState({
                                showModal: true
                              })
                            }
                          >
                            <Icon name="check" />
                            Update
                          </Button>

                          <Form>
                            <Form.Group>
                              <Form.Input
                                transparent
                                label="Invoice Amount"
                                value={"$" + Roundy(invoice.amount)}
                              />
                              <Form.Input
                                label="Paid Amount"
                                transparent
                                value={"$" + invoice.paidamount}
                              />
                            </Form.Group>
                          </Form>
                        </Table.Cell>
                        <Table.Cell>
                          <h5> Budget </h5> <h5>Prev Year Adj</h5>
                          <h5> Remaining </h5>
                        </Table.Cell>
                        <Table.Cell>
                          <h5>
                            $
                            {Roundy(parseFloat(invoice.rootwod.budget) +
                              parseFloat(invoice.rootwod.supplements))}
                          </h5>
                          <h5> $ {invoice.rootwod.prevYearAdj} </h5>
                          <h5> $ {invoice.Remaining} </h5>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Footer>
                  </Table>
                  <Divider />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <PaymentModal
              {...this.props}
              payInvoice={invoice}
              editPayment={payment => updateservice("payments", payment, payment.id).then(t => this.grabInvoice())}
              newPayment={payment => createservice("payments", {...payment, invoice_id: invoice.id}).then(t => this.grabInvoice())}
              deletePayment={payment => deleteservice("payments", payment.id).then(() => this.grabInvoice())}
              updateComments={comments =>
                updateservice(
                  "invoices",
                  {
                    ...invoice,
                    invcomments: comments
                  },
                  invoice.id
                ).then(t => this.grabInvoice())
              }
              showModal={this.state.showModal}
              handleClose={() =>
                this.setState({
                  showModal: false
                })
              }
            />
            <Modal
              open={this.state.orphan_modal}
              onClose={() =>
                this.setState({
                  orphan_modal: false,
                  orphan_tms: [],
                  included_tms: []
                })
              }
              centered={false}
            >
              <Modal.Header>Manage T&MS</Modal.Header>
              <Modal.Content>
                <h3>
                  Included T&MS
                  <span>
                    <Button
                      icon
                      negative
                      id="tm_modal_btn"
                      disabled={!this.state.included_tms.length}
                      onClick={() => this.remove_tnms()}
                    >
                      <Icon name="minus" /> Remove T&M's
                    </Button>
                  </span>
                </h3>
                <Table id="tmtable" basic="very">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>WO#</Table.HeaderCell>
                      <Table.HeaderCell>TM Number</Table.HeaderCell>
                      <Table.HeaderCell>Week End Date</Table.HeaderCell>
                      <Table.HeaderCell>Labor Charge</Table.HeaderCell>
                      <Table.HeaderCell>Material Charge</Table.HeaderCell>
                      <Table.HeaderCell />
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>{this.gentmlistTable()}</Table.Body>
                </Table>

                <h3>
                  Orphaned T&MS
                  <span>
                    <Button
                      icon
                      positive
                      id="tm_modal_btn"
                      onClick={() => this.add_orphaned_tnms()}
                      disabled={!this.state.orphan_tms.length}
                    >
                      <Icon name="plus" /> Add T&M's
                    </Button>
                  </span>
                </h3>
                <Table id="tmtable" basic="very">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>WO#</Table.HeaderCell>
                      <Table.HeaderCell>TM Number</Table.HeaderCell>
                      <Table.HeaderCell>Week End Date</Table.HeaderCell>
                      <Table.HeaderCell>Labor Charge</Table.HeaderCell>
                      <Table.HeaderCell>Material Charge</Table.HeaderCell>
                      <Table.HeaderCell />
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>{this.genorphantmlistTable()}</Table.Body>
                </Table>
              </Modal.Content>
            </Modal>
          </div>
        );
      }
    } else {
      return (
        <div>
          <h2> Loading Time and materials... </h2>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    access: state.myinfo.accessstatus,
    modalstatus: state.modal,
    custinfo: state.custinfo.customers,
    billing: state.custinfo.billing,
    invoices: state.invoices.all,
    wods: state.workorders.derivitives,
    jobs: state.jobs.assignedjobs,
    tnms: state.tnms.all,
    myinfo: state.myinfo.employeeinfo
  };
}
export default connect(mapStateToProps)(invpdf);



// WEBPACK FOOTER //
// ./src/components/pdf/invpdf.js